import axios from 'axios'
import { ZKEX_BROKER_BASE_URL } from 'config'
import { L1ChainId, TokenId, Wei } from '../../types'

export async function getBrokerPrice<
  T extends {
    code: number
    data: {
      available: Wei
      fee: number
      limit: Wei
    }
  },
>(chainId: L1ChainId, tokenId: TokenId) {
  return await axios
    .get<T>(`/price/${chainId}/${tokenId}`, {
      baseURL: ZKEX_BROKER_BASE_URL,
    })
    .then((r) => r.data)
    .then((r) => r.data)
}
